import { useContext } from 'react';
import { FluxibleContext } from './FluxibleContext';
export var useFluxible = function () {
    return useContext(FluxibleContext);
};
